import React, { useEffect, useState } from 'react';
import { callApi } from '../../../api/call';
import DeluxeEmbeddedPaymentForm from '../DeluxeEmbeddedPaymentForm';
import { getDeluxeEnvironment } from '../../../website/services/payment/deluxeEnvironment';

const DeluxeSubscriptionCheckout = ({
  amount,
  billingCycle,
  customer,
  description,
  environment,
  disabled = false,
  onPaid,
}) => {
  const [config, setConfig] = useState(null);
  const [error, setError] = useState('');

  const firstName = customer?.firstName || '';
  const lastName = customer?.lastName || '';
  const email = customer?.email || '';
  const address = customer?.billingAddress?.address || '';
  const city = customer?.billingAddress?.city || '';
  const state = customer?.billingAddress?.state || '';
  const zipCode = customer?.billingAddress?.zipCode || '';
  const ready = Number(amount) > 0 && firstName && lastName && address && city && state && zipCode;

  useEffect(() => {
    if (!ready || disabled) return undefined;
    let cancelled = false;
    setConfig(null);
    setError('');
    callApi('/api/payments/deluxe/hosted-form', {
      scope: 'platform',
      mode: 'subscription',
      amount,
      billingCycle,
      description,
      environment: environment || getDeluxeEnvironment(),
      managementUrl: window.location.origin,
      customer: {
        firstName,
        lastName,
        email,
        billingAddress: { address, city, state, zipCode },
      },
    }, { auth: false })
      .then((res) => {
        if (!cancelled) setConfig(res.data);
      })
      .catch((err) => {
        if (!cancelled) setError(err?.message || 'Deluxe is not configured in admin App Settings');
      });
    return () => {
      cancelled = true;
    };
  }, [ready, disabled, amount, billingCycle, description, environment, firstName, lastName, email, address, city, state, zipCode]);

  if (!ready) {
    return <p className="deluxe-embedded__status">Enter the billing address to load the payment form.</p>;
  }
  if (error) {
    return <div className="deluxe-embedded__error" role="alert">{error}</div>;
  }
  if (!config?.jwt) {
    return <p className="deluxe-embedded__status">Loading Deluxe payment form…</p>;
  }

  return (
    <DeluxeEmbeddedPaymentForm
      jwt={config.jwt}
      scriptUrl={config.scriptUrl}
      mode="subscription"
      disabled={disabled}
      onSuccess={(result) => onPaid?.(result)}
      onError={(err) => setError(err?.message || 'Payment failed')}
    />
  );
};

export default DeluxeSubscriptionCheckout;
